import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import {
  defaultDataZoom,
  parseDataZoom,
  preprocessDataZoom
} from '../../ainvest/component/datazoom';

const defaultDataZoomOpt = {
  // 设计师想要dataZoom的左右边距跟随grid
  // echarts 源码的默认值是left: null, right: 'ph' 是为了让 echarts 自动根据grid计算
  left: null,
  right: 'ph',
  top: 197
};

export function dataZoomThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preprocessDataZoom(option);
  const dataZoomConfig = defaultDataZoom(themeMode);
  parseDataZoom(option, [
    dataZoomConfig[0],
    util.merge(dataZoomConfig[1], defaultDataZoomOpt, true)
  ]);
}
